module.exports = __webpack_public_path__ + "static/chandelier-cleaning-edmonton-3a3a241bfd97768f3f93e22793a453e3.jpg";